export default __webpack_public_path__ + "static/cod-673e168c755d7395d1875e720eadb3a8.jpeg";